import { IRectangle, List } from '@fluentui/react';
import { SocialAccountModel } from '../../models/SocialAccountModel';
import AccountItemView from './AccountItemView';

type AccountGridProps = {
    accounts: SocialAccountModel[];
    onEdit: (account: SocialAccountModel) => void;
    onDelete: (account: SocialAccountModel) => void;
}

export default function AccountGridView({ accounts, onEdit, onDelete }: AccountGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return accounts.length;
    }

    const onRenderCell = (account?: SocialAccountModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (account == null) return <>empty</>;

        return <div
            key={account.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width, height: "auto" }}
            data-is-focusable={true}
        >
            <AccountItemView
                key={account.id}
                account={account}
                onEdit={onEdit}
                onDelete={onDelete}
            />
        </div>;
    }

    return <div className="ml--20 mr--20">
        <List
            items={accounts}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}